
import type { RefresherEventDetail } from '@ionic/core/components';
import {
  IonContent,
  IonPage,
  IonItem,
  IonToolbar,
  IonSkeletonText,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonIcon,
  IonModal,
  IonHeader,
  IonButtons,
  IonButton,
  useIonToast,
  IonLoading,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { chevronDownCircleOutline, close, rocketOutline } from 'ionicons/icons';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import Clock from '../../assets/Clock.svg';
import CreateAsset from '../../assets/CreateAsset.svg';
import axios from '../../axios';
import Header from '../../components/Header';
import NoRecords from '../../components/NoRecords';
import ScanButton from '../../components/ScanButton';
import { createServiceFields, updateServiceRequest } from '../../models/createServiceFields';
import { AppContext } from '../../providers/AppContext';
import { isFormDataEmpty } from '../../utils';

const ServiceHome: React.FC = () => {
  const { state } = useContext(AppContext);

  const isMounted = useRef(true);

  const { t } = useTranslation();
  const [present] = useIonToast();
  const history = useHistory();
  const [data, setData] = useState<any>([]);

  const [highlights, setHighlights] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);


  const [fabModal, setFabModal] = useState(false);
  const [rname, setRname] = useState(''); // Repair Name

  const [_data, set_Data] = useState<any>(createServiceFields);
  const [updateRequest, setUpdateRequest] = useState(updateServiceRequest);
  const [showLoading, setShowLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState<boolean>(false);

  const [primaryData, setPrimaryData] = useState<any>({});

  const handleChange = (event: any) => {
    const formentry: any = [...updateRequest];
    const f_index = formentry.findIndex((v: any) => v.field === event.target.id);
    const change_form_object = formentry[f_index];
    change_form_object.value = event.target.value;
    formentry[f_index] = change_form_object;
    setUpdateRequest(formentry);
  };

  const handleSelectChange = (event: any) => {
    const formentry: any = [...updateRequest];

    const select = event.target.name.replaceAll('-', '_');
    const f_index = formentry.findIndex((v: any) => v.field === select);
    formentry[f_index].value = event.target.value;
    setUpdateRequest(formentry);
  };

  const getData = (context: any) => {
    isMounted.current = true; // Set isMounted to true
    const isFiltered = context.isFiltered || false;
    const pageToFetch = isFiltered ? 0 : currentPage;
    const limit = 10;
    const url = `/method/preflet_asset.api.get_assigned_repair_requests?limit=${limit}&start=${pageToFetch * limit}`

    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    return axios(config)
      .then((res: any) => {
        if (isMounted?.current) {
          console.log(res?.data?.message?.repair_request_list)
          const newList = res?.data?.message?.repair_request_list || [];
          if (isFiltered) {
            setHighlights(newList);
            setCurrentPage(1);
          } else {
            setHighlights((prev: any) => [...prev, ...newList]);
            setCurrentPage(pageToFetch + 1);
          }
          setDisableInfiniteScroll(newList.length < limit);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        if (isMounted.current)
          setLoader(false);
      });
  };

  const searchNext = ($event: CustomEvent<void>) => {
    getData({}).finally(() => {
      ($event.target as HTMLIonInfiniteScrollElement).complete();
    });
  };


  useEffect(() => {
    getData({});
    // Cleanup function
    return () => {
      isMounted.current = false; // Mark the component as unmounted when it's being cleaned up
      // You can also cancel any subscriptions or clean up other resources here
    };
  }, []);

  // useIonViewWillLeave(() => {
  //   if (fabModal) {
  //     setFabModal(false);
  //   }
  // });


  function doRefresh(event: CustomEvent<RefresherEventDetail>) {
    setDisableInfiniteScroll(false);
    getData({ isFiltered: true }).finally(() => {
      event.detail.complete();
    });
  }

  const modalFunc = async (param: any) => {
    isMounted.current = true; // Set isMounted to true
    if (isMounted.current)
      setFabModal(true);
    const config: any = {
      method: 'get',
      url: `/resource/Repair Request/${param}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    try {
      const res = await axios(config)
      const temp = res.data.data;
      if (isMounted.current)
        setPrimaryData(temp);
      const Data = [..._data];
      for (const x in Data) {
        const f = Data[x].field;
        if (f === 'status' || f === 'remarks' || f === 'responsibility') {
          const formentry: any = [...updateRequest];
          const f_index = formentry.findIndex((v: any) => v.field === Data[x].field);
          formentry[f_index].value = f && temp[f];
          if (isMounted.current)
            setUpdateRequest(formentry);
        }
        if (f) {
          Data[x].value = temp[f];
        }
      }
      if (isMounted.current)
        set_Data(Data);
    } catch (error: any) {
      console.log(error)
    }
  }


  const repairSubmit = async (e: any) => {
    e.preventDefault();
    const formData = new FormData();
    const api_data: any = {};
    updateRequest.map((_entry: any) => {
      if (_entry.field === 'responsibility' && localStorage.getItem('isPrezero') !== 'true') {
        return;
      }
      api_data[_entry.field] = _entry.value;

      if (primaryData[_entry.field] !== _entry.value) {
        formData.append(_entry.field, _entry.value);
      }
    });



    const config: any = {
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: formData,
    };

    if (!isFormDataEmpty(formData)) {
      try {
        setShowLoading(true);
        const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
        const urlPart = `method/preflet_asset.api.update_repair_request/${rname}`;
        const fetchUrl = urlPart.startsWith('http')
          ? urlPart
          : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

        const response = await fetch(fetchUrl, {
          method: 'PUT',
          headers: config.headers,
          body: formData,
        });

        if (!response.ok && response.status !== 200) {
          throw new Error('Update failed');
        }

        present({
          message: t('Service.serviceUpdate'),
          duration: 2000,
        });
        setFabModal(false);
        reset();
        history.push({
          pathname: '/servicehome',
          state: '',
        });
      } catch (error: any) {
        console.log(error)
      } finally {
        setShowLoading(false);
      }
    } else {
      setFabModal(false);
    }
  };



  const reset = () => {
    for (const x in updateRequest) {
      updateRequest[x].value = '';
    }
  };


  const getStatusBadge = (item: any) => {
    const isOverdue = item.target_date && new Date(item.target_date).toLocaleDateString() < new Date().toLocaleDateString();
    return isOverdue;
  };

  return (
    <IonPage>
      <Header enableBackButton='' title="" />
      <IonContent>

        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent
            pullingIcon={chevronDownCircleOutline}
            pullingText={t('Utils.pullRefresh')}
            refreshingSpinner="circles"
            refreshingText={t('Utils.refreshing')}
          />
        </IonRefresher>

        {/* ── Hero Banner ── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #0f3460 100%)',
          padding: '16px 16px 16px',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: -30, right: -30, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
          <div style={{ position: 'absolute', bottom: -20, left: -20, width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />

          <p style={{ margin: 0, fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.12em', textTransform: 'uppercase', position: 'relative', zIndex: 1, marginBottom: '1rem' }}>
            {t('Service.Recent')}
          </p>
          {/* <h1 style={{ margin: '3px 0 12px', fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.15, position: 'relative', zIndex: 1 }}>
            Service
          </h1> */}

          {/* Quick action buttons inside banner */}
          <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4, position: 'relative', zIndex: 1 }}>
            {!!state.permissions.service_request_create && (
              <Link to="./serviceCreate" style={{ textDecoration: 'none', flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#fff', borderRadius: 14, padding: '10px 16px', boxShadow: '0 4px 16px rgba(29,80,141,0.15)', border: '1.5px solid rgba(29,80,141,0.1)', cursor: 'pointer' }}>
                  <img src={CreateAsset} alt="create" style={{ width: 18, height: 18 }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1d508d', whiteSpace: 'nowrap' }}>{t('Service.Create')}</span>
                </div>
              </Link>
            )}
            <Link to="./serviceHistory" style={{ textDecoration: 'none', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.15)', borderRadius: 14, padding: '10px 16px', border: '1.5px solid rgba(255,255,255,0.3)', cursor: 'pointer' }}>
                <img src={Clock} alt="history" style={{ width: 16, height: 16, filter: 'brightness(10)' }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>{t('Service.History')}</span>
              </div>
            </Link>
          </div>
        </div>

        {/* ── Section Header ── */}
        <div style={{ padding: '16px 16px 6px' }}>
          <p style={{ margin: 0, fontSize: 15, fontWeight: 800, color: '#1d508d' }}>{t('Service.Recent')}</p>
        </div>

        {/* ── Skeleton Loaders ── */}
        {loader && [1, 2, 3, 4].map((el) => (
          <div key={el} style={{ margin: '0 12px 10px', background: '#fff', borderRadius: 16, padding: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <IonSkeletonText animated style={{ width: '55%', height: 16, borderRadius: 8 }} />
              <IonSkeletonText animated style={{ width: '20%', height: 16, borderRadius: 8 }} />
            </div>
            <IonSkeletonText animated style={{ width: '40%', height: 12, borderRadius: 8 }} />
          </div>
        ))}

        {/* ── Service Request Cards ── */}
        <div style={{ padding: '0 12px' }}>
          {highlights && highlights.length > 0 && highlights.map((item: any, key: number) => {
            const isOverdue = getStatusBadge(item);
            return (
              <div key={key} style={{
                background: '#fff',
                borderRadius: 18,
                padding: '14px 16px',
                marginBottom: 10,
                boxShadow: '0 3px 14px rgba(0,0,0,0.07)',
                border: `1.5px solid ${isOverdue ? 'rgba(224,60,90,0.15)' : 'rgba(29,80,141,0.07)'}`,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                {/* Left: name + asset + overdue chip */}
                <Link
                  to={{ pathname: '/serviceDetail', state: item.name, search: 'back=servicehome' }}
                  style={{ textDecoration: 'none', flex: 1, minWidth: 0 }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1d2d44' }}>{item.name}</p>
                    {isOverdue && (
                      <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: 'rgba(224,60,90,0.1)', color: '#e03c5a', border: '1px solid rgba(224,60,90,0.25)', whiteSpace: 'nowrap' }}>
                        {t('Assets.Details.overdue')}
                      </span>
                    )}
                  </div>
                  {item.asset && (
                    <p style={{ margin: '5px 0 0', fontSize: 12, color: '#6b7b8f' }}>
                      {t('Assets.Details.AID')}: <span style={{ fontWeight: 600, color: '#1d508d' }}>{item.asset}</span>
                    </p>
                  )}
                </Link>

                {/* Right: quick-update rocket button */}
                {!!state.permissions.service_request_update && (
                  <div
                    onClick={() => { modalFunc(item.name); setRname(item.name); }}
                    style={{
                      flexShrink: 0,
                      marginLeft: 12,
                      width: 36, height: 36,
                      borderRadius: '50%',
                      background: 'rgba(29,80,141,0.08)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <IonIcon src={rocketOutline} style={{ color: '#1d508d', fontSize: 17 }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <IonInfiniteScroll
          threshold="100px"
          disabled={disableInfiniteScroll}
          onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}
        >
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText={t('Utils.pleasewait')}
          />
        </IonInfiniteScroll>

        {/* ── Empty State ── */}
        {!loader && highlights.length === 0 && (
          <IonRow>
            <NoRecords width="30%" smallText={true} />
          </IonRow>
        )}

        {/* ── Quick-Update Modal (unchanged) ── */}
        <IonModal isOpen={fabModal} onDidDismiss={() => setFabModal(false)}>
          <IonHeader>
            <IonToolbar color="primary">
              &nbsp; {rname}
              <IonButtons slot="end">
                <IonButton className="line-button" onClick={() => { setFabModal(false); reset(); }}>
                  <IonIcon icon={close} slot="icon-only" />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonLoading isOpen={showLoading} onDidDismiss={() => setShowLoading(false)} message={'Please wait...'} />
            <div className="data-list">
              {_data.map((item: any, key: any) => {
                if (item.field === 'target_date' || item.field === 'asset' || item.field === 'date' || item.field === 'name1' || item.field === 'fault_type' || item.field === 'status' || item.field === 'priority') {
                  return (
                    <div className="preview-container" key={key}>
                      <p className='preview-key'>{t(item.label)}</p>
                      <p className='preview-value'>{item.value}</p>
                    </div>
                  );
                }
              })}
            </div>
            <form onSubmit={(e) => repairSubmit(e)}>
              {updateRequest.map((form_field: any, index: any) => {
                if (form_field.field === 'responsibility' && localStorage.getItem('isPrezero') !== 'true') return null;
                if (form_field.type === 'text') {
                  return (
                    <div key={`${form_field.label}-${index}`} className="input-container">
                      <label className="label">{t(form_field.label)}{form_field.required ? '*' : ''}</label>
                      <input required={form_field.required} className="basic-input" key={`${form_field.field}-${index}`} id={form_field.field} placeholder={t(form_field.label)} onChange={handleChange} value={form_field.value} />
                    </div>
                  );
                } else if (form_field.type === 'textarea') {
                  return (
                    <div key={`${form_field.label}-${index}`} className="input-container">
                      <label className="label">{t(form_field.label)}{form_field.required ? '*' : ''}</label>
                      <textarea className="textarea" required={form_field.required} key={`${form_field.field}-${index}`} id={form_field.field} placeholder={t(form_field.label)} onChange={handleChange} value={form_field.value} />
                    </div>
                  );
                } else if (form_field.type === 'select') {
                  return (
                    <div key={`${form_field.label}-${index}`} className="input-container">
                      <label className="label">{t(form_field.label)}{form_field.required ? '*' : ''}</label>
                      <Select className="custom-select" required={form_field.required} id={`${form_field.field}_choice`} name={form_field.field} onChange={handleSelectChange} value={form_field.value} key={`${form_field.field}-${index}`}>
                        {form_field.options?.map(function (opt: any, indexSelect: any) {
                          return (
                            <MenuItem value={`${opt}`} key={`${form_field.field}-${indexSelect}`} id={`${opt}_item_${indexSelect}`}>
                              <section style={{ display: 'flex', height: '1rem' }}>
                                <p style={{ color: 'rgba(31, 87, 148, 1)', marginLeft: '0.2rem', fontSize: '12px', marginTop: '0px' }}>{t(opt)}</p>
                              </section>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  );
                } else if (form_field.type === 'date') {
                  return (
                    <div key={`${form_field.label}-${index}`} className="input-container">
                      <label className="label">{t(form_field.label)}{form_field.required ? '*' : ''}</label>
                      <input required={form_field.required} className="date" key={`${form_field.field}-${index}`} id={form_field.field} placeholder={t(form_field.label)} onChange={handleChange} value={form_field.value} type="date" />
                    </div>
                  );
                } else { return ''; }
              })}
              <button className="submit-button" type="submit">{t(`Assets.CreateA.update`)}</button>
            </form>
          </IonContent>
        </IonModal>

        <ScanButton isAssetPage={false} />
      </IonContent>
    </IonPage>
  );
};
export default ServiceHome;

